//@ts-nocheck
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Navbar, NavbarBrand, Nav, NavItem, NavLink, Container, Row, Col, Button } from "reactstrap";
import { CSS } from "src/_utils/styles";
import { Layout } from "src/base/store/layoutSlice";
import { ReduxDataKey } from "src/base/store/store";
import { CardBody, Card, CardHeader } from "reactstrap";
import { CarouselsData } from "../../Data/Bonus-ui";
import Image from "../../CommonElements/Media";
import Slider from "react-slick";
import { H5 } from "../../AbstractElements";
import { remotePath } from "src/base/settings/Paths";
import { useEBSSSLayout } from "src/base/context/EBSSSLayoutContext/useEBSSSLayout";
import { Link, useNavigate } from "react-router-dom";
import { Session } from "src/base/store/authSlice";
import { SellerSidebar } from "../Seller/SellersCommon";
import { ProductSidebar } from "../Products/ProductsCommon";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import EBSSSChatContainer from "src/base/atoms/EBSSSChatContainer";
import { RenderReactChatInstance } from "src/assets/chat/chat";
import { useEBSSS } from "src/base/context/EBSSSContext/useEBSSS";
import { EBSSSChatModule } from "src/assets/chat/core";

export const LeftArrowSlider = (props) => {
  const { className, style, onClick } = props;
  return (
    <div className={className} style={{ ...style, display: "block", background: "#fff", borderRadius: "50%", color: "#000" }} onClick={onClick}>
      <i className="fa fa-arrow-left"></i>
    </div>
  );
};

export const RightArrowSlider = (props) => {
  const { className, style, onClick } = props;
  return (
    <div className={className} style={{ ...style, display: "block", background: "#fff", borderRadius: "50%", color: "#000" }} onClick={onClick}>
      <i className="fa fa-arrow-right"></i>
    </div>
  );
};

export const SlickSlider = ({ slides, rtl, title, lazyLoad, autoplay, focusOnSelect, isGallery, CTA }) => {
  var settings = {
    arrows: true,
    dots: true,
    infinite: true,
    autoplay: autoplay,
    speed: 100,
    slidesToShow: 4,
    slidesToScroll: 1,
    adaptiveHeight: true,
    centerPadding: "10px",
    centerMode: false,
    rtl: rtl,
    focusOnSelect: focusOnSelect,
    lazyLoad: lazyLoad,
    nextArrow: <RightArrowSlider />,
    prevArrow: <LeftArrowSlider />,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <Card>
      <CardHeader className="pb-0">
        <H5>{title}</H5>
      </CardHeader>
      <CardBody>
        <div className="mb-3" style={{ minHeight: 150 }}>
          <Slider {...settings}>
            {slides.map((item, index) => (
              <div key={index} className="slider-item" style={{ padding: "10px" }}>
                {isGallery ? (
                  <Zoom>
                    <img
                      alt="Slider"
                      src={remotePath.assetsUrl(item.image)}
                      style={{
                        width: "100%",
                        height: "auto",
                        maxHeight: "150px", // Adjust if needed
                        objectFit: "contain",
                      }}
                    />
                  </Zoom>
                ) : (
                  <div style={{ textAlign: "center" }}>
                    {item.image ? (
                      <img
                        src={remotePath.assetsUrl(item.image)}
                        alt=""
                        style={{
                          width: "100%",
                          height: "auto",
                          maxHeight: "150px", // Adjust as needed
                          objectFit: "contain",
                        }}
                      />
                    ) : (
                      <img
                        src="https://cdn.pixabay.com/photo/2022/01/12/00/27/gallery-6931706_1280.png"
                        alt=""
                        style={{
                          width: "100%",
                          height: "auto",
                          maxHeight: "150px", // Adjust as needed
                          objectFit: "contain",
                        }}
                      />
                    )}
                    {item.title && <p>{item.link ? <Link to={item.link}>{item.title}</Link> : item.title}</p>}
                  </div>
                )}
              </div>
            ))}
          </Slider>
        </div>
        <div className="d-flex">{CTA}</div>
      </CardBody>
    </Card>
  );
};

const getProps = (data) => {
  const regex = /<(\w+)>(.*?)<\/\1>/g; // Matches opening tag, content, and closing tag
  const result = {};
  let match;

  while ((match = regex.exec(data)) !== null) {
    const key = match[1]; // The tag name (e.g., "title", "subtitle")
    const value = match[2]; // The content inside the tag
    result[key] = value; // Dynamically add key-value pair to the object
  }

  return result;
};

const IndexPage = () => {
  const ebsssLayout: Layout = useSelector((state) => state[ReduxDataKey.LAYOUT]);
  const sessionNow: Session = useSelector((state) => state[ReduxDataKey.AUTH]);
  const { trans } = useEBSSSLayout();
  const pageData: Record<string, any> = getProps(ebsssLayout.commonAppSettings?.crm_v2_default_homepage_content);
  const [selectedFilter, setSelectedFilter] = useState("product");
  console.log("pageData: ", pageData, ebsssLayout);
  const { hasChats, chatDataSetter, chatDataPreview, loaded, setChatDataPreview, setChatDataSetter } = useEBSSS();

  return (
    <div>
      {/* Main Content */}
      <Container className="my-5">
        <div className="pt-4 mb-4 row">
          <h2 className="mb-4">{pageData?.title}</h2>
          <h4 className="mb-4">{pageData?.subtitle}</h4>
          <div className="col-6 col-md-3">
            <div className="form-group">
              <select className="form-control" name="select-filter" id="select-filter" onChange={(e) => setSelectedFilter(e.target.value)}>
                <option value="product">{trans("website.products")}</option>
                <option value="seller">{trans("website.sellers")}</option>
              </select>
            </div>
          </div>
          <div className="col-6 col-md-9">{selectedFilter === "product" ? <ProductSidebar onlyInput /> : <SellerSidebar onlyInput />}</div>
        </div>

        {ebsssLayout.defaultHomepage.pictures && ebsssLayout.defaultHomepage.pictures?.length > 0 ? (
          <SlickSlider
            slides={
              ebsssLayout.defaultHomepage.pictures?.map((d) => {
                return {
                  id: d.id,
                  image: d.path,
                  title: "",
                };
              }) ?? []
            }
            isGallery
            lazyLoad={true}
            rtl={false}
          />
        ) : (
          <></>
        )}

        <h2 id="sellers" className="text-center mb-4 mt-4 pt-4">
          {trans("website.products")}
        </h2>

        {ebsssLayout.defaultHomepage.best_sellers && ebsssLayout.defaultHomepage.best_sellers?.length > 0 ? (
          <SlickSlider
            slides={
              ebsssLayout.defaultHomepage.best_sellers?.map((d) => {
                return {
                  id: d.id,
                  image: d.photo,
                  title: d.name,
                  link: process.env.PUBLIC_URL + "/crm/products/" + d.slug,
                };
              }) ?? []
            }
            lazyLoad={true}
            title={trans("website.most-sold")}
            rtl={false}
            CTA={
              ebsssLayout.defaultHomepage.best_sellers?.length > 4 ? (
                <Link className="btn shadow-sm text-primary m-auto mt-5" to={process.env.PUBLIC_URL + "/crm/products"}>
                  {trans("website.view-all")}
                </Link>
              ) : (
                <></>
              )
            }
          />
        ) : (
          <></>
        )}

        {/* About Section */}
        <h2 id="sellers" className="text-center mb-4 mt-4 pt-4">
          {trans("website.sellers")}
        </h2>

        {ebsssLayout.commonAppSettings?.sys_multi_sellers &&
        ebsssLayout.defaultHomepage.sellers_by_category &&
        ebsssLayout.defaultHomepage.sellers_by_category?.length > 0 ? (
          ebsssLayout.defaultHomepage.sellers_by_category?.map((sc) => {
            return (
              <SlickSlider
                slides={sc.companies.map((d) => {
                  return {
                    id: d.id,
                    image: d.photo ? d.photo : d?.profile?.avatar,
                    title: d.fullName,
                    link: process.env.PUBLIC_URL + "/crm/seller/" + d.username,
                  };
                })}
                lazyLoad={true}
                title={sc.title}
                rtl={false}
                CTA={
                  sc.companies?.length > 4 ? (
                    <Link className="btn shadow-sm text-primary m-auto mt-5" to={process.env.PUBLIC_URL + "/sellers"}>
                      {trans("website.view-all")}
                    </Link>
                  ) : (
                    <></>
                  )
                }
              />
            );
          })
        ) : (
          <></>
        )}
      </Container>
      <div style={CSS({ display: !loaded ? "none" : "block" })}>
        {hasChats?.length > 0 ? (
          hasChats?.map((ch) => {
            console.log("Guid config: ", ch);
            if (ch.type !== "pop") return <></>;
            if (localStorage.getItem("NOT_FOUND_CHAT_" + ch.guid) === "true") return <></>;
            //@ts-ignore
            new EBSSSChatModule(ch).init();
            return (
              <EBSSSChatContainer chatDataSetter={chatDataSetter} guidData={ch} chatDataPreview={chatDataPreview}>
                <RenderReactChatInstance
                  {...(ch as any)}
                  sufixGUID={ch.guid}
                  chatDataSetter={chatDataSetter}
                  setChatDataSetter={setChatDataSetter}
                  setChatDataPreview={setChatDataPreview}
                />
              </EBSSSChatContainer>
            );
          })
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default IndexPage;
